import React from 'react';
import { setCookie } from 'nookies';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { Store } from '../../pagepart/store/Store';
import { BasicPortalStructure } from '../../pagepart/layout/BasicPortalStructure';
import { SigninButtonGoogle } from '../../pagepart/auth/SigninButtonGoogle';
import { StoreContext } from 'src/pagepart/utils';
import { Env } from '../../env/Env';
import { ServerProps } from '../../pagepart/portal/utils';
import { BasicAuthBox } from '../../pagepart/auth/BasicAuthBox';
import { SigninButtonFacebook } from '../../pagepart/auth/SigninButtonFacebook';
import { SigninButtonEmail } from '../../pagepart/auth/SigninButtonEmail';
import { Access } from '../../server/control/Access';
import { SigninButtonPassword } from '../../pagepart/auth/SigninButtonPassword';
import { SigninButtonCode } from '../../pagepart/auth/SigninButtonCode';
import { SigninButtonGoogleOneTap } from '../../pagepart/auth/SigninButtonGoogleOneTap';
import { SigninButtonApple } from '../../pagepart/auth/SignInButtonApple';
// import { SigninButtonApple } from '../../pagepart/auth/SignInButtonApple';

export async function getServerSideProps(rawContext) {
  const { env } = await Env.forNextContext(rawContext, new Access({ userEnv: true }));

  if (env.requestEnv.get.inline) {
    setCookie(env.userEnv.cookieContext, 'inline', '1', {
      maxAge: 24 * 60 * 60,
      path: '/',
    });
    env.requestEnv.cookies.inline = '1';
  }

  return {
    props: {
      ...env.transfer,
    },
  };
}

class Signin extends React.Component<ServerProps<typeof getServerSideProps>> {
  @memoize
  get store() {
    return Store.forApp(this);
  }

  setupPage(store: Store) {
    store.portalStore.metaTitle = 'Schlaukopf Login';
    store.portalStore.includeStylesheetOnce('/static/dist7/assets/css/pages/login/classic/login-4.css');
  }

  get loginContent() {
    return (
      <>
        {/*begin::Login forgot password form*/}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div className="mb-5">
            <h3>Anmelden bei Schlaukopf</h3>
            <div className="text-muted font-weight-bold">Wähle deinen Login-Provider.</div>
          </div>

          {this.store.requestStore.requestData.isWebViewInIosApp && <SigninButtonApple />}
          <SigninButtonGoogle />
          <SigninButtonFacebook />
          <SigninButtonEmail />
          <SigninButtonPassword />
          <SigninButtonCode />
          {!this.store.userStore.isPremium && <SigninButtonGoogleOneTap />}
        </div>

        {/*end::Login forgot password form*/}
      </>
    );
  }

  render() {
    return (
      <StoreContext.Provider value={this.store}>
        <BasicPortalStructure aside={null} content={<BasicAuthBox>{this.loginContent}</BasicAuthBox>} />
      </StoreContext.Provider>
    );
  }
}

export default Signin;
